import DatabaseModel from './DatabaseModel.js';

var RepartoContratacion = Object.create(DatabaseModel);

RepartoContratacion.model = 'reparto-contratacion';

export default RepartoContratacion;